export default function floorToNearestMultiple(
  num: number,
  base: number
): number {
  return Math.floor(num / base) * base;
}
